/* eslint-disable no-restricted-properties */

class LocalStorage {
    setItem (key: string, value: unknown): void {
        try {
            window.localStorage.setItem(key, JSON.stringify(value))
        } catch (e) {
            console.error(e)

            if (!(e instanceof DOMException) || e.name !== 'QuotaExceededError') {
                return
            }

            const oldestKey = window.localStorage.key(0)
            if (oldestKey === null) return

            /* eslint-disable-next-line no-console */
            console.info('Removing localStorage key: ' + oldestKey)
            window.localStorage.removeItem(oldestKey)
            this.setItem(key, value)
        }
    }

    getItem (key: string): null | unknown {
        const value = window.localStorage.getItem(key)
        try {
            return value ? JSON.parse(value) : null
        } catch {
            return null
        }
    }

    removeItem (key: string): void {
        window.localStorage.removeItem(key)
    }
}

export default new LocalStorage()
